import { useLocation, useNavigate } from 'react-router-dom';
import './NotAllowed.css';
import { useAuth } from '../../contexts/auth';
import Button from '../../components/Button/Button';
import { TbBarrierBlock } from "react-icons/tb";
import { useEffect } from 'react';
import { routes } from '../../routes/routes-identity';
import { useUserStore } from '../../contexts/userStore';

export function NotAllowed() {
	const { signOut, user, can } = useAuth();
	const location = useLocation();
	const navigate = useNavigate();

	function onSignOutClick() {
		signOut();
		navigate("/login");
	}

	useEffect(() => {
		if (user && location.state?.ref) {
			const currentRoute = routes.find(
				(route) => route.path === location.state?.ref
			);
			if (!currentRoute) return;
			if (user.userData.isSuperAdmin || !currentRoute.action || can?.(currentRoute.action)) {
				console.log('Not Allowed State: ', location.state);
				navigate(location.state.ref);
			}
		}
	}, [user])

	return (
		<div className='container'>
			<div className='not-allowed-wrapper'>
				<TbBarrierBlock size={72} color='#ff6d6d' />
				<h2>Acesso não permitido!</h2>
				<p>Você não possui permissões nas políticas de sua organização para acessar essa página. Solicite acesso a um administrador de sua unidade</p>
				<p>ou faça login com outra conta.</p>
				<Button onClick={e => onSignOutClick()} label='Ir para o login' />
			</div>
		</div>
	);
}